import { lazy, Suspense } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";
import PublicLayout from "./components/PublicLayout";
import { usePreferences } from "./context/AppContext";
import { makeTheme } from "./theme";

const HomePage = lazy(() => import("./pages/HomePage"));
const publicPage = (name) => lazy(() => import("./pages/PublicPages").then((module) => ({ default: module[name] })));
const adminPage = (name) => lazy(() => import("./pages/AdminPages").then((module) => ({ default: module[name] })));
const AboutPage = publicPage("AboutPage");
const SatsangPage = publicPage("SatsangPage");
const EventsPage = publicPage("EventsPage");
const EventDetailPage = publicPage("EventDetailPage");
const AudioPage = publicPage("AudioPage");
const VideosPage = publicPage("VideosPage");
const GalleryPage = publicPage("GalleryPage");
const ContactPage = publicPage("ContactPage");
const LegalPage = publicPage("LegalPage");
const NotFoundPage = publicPage("NotFoundPage");
const AdminLoginPage = adminPage("AdminLoginPage");
const ProtectedAdmin = adminPage("ProtectedAdmin");

function RouteLoader() {
  return <div className="route-loader"><span className="loader-ring" /><span>Opening the page…</span></div>;
}

export default function App() {
  const { mode } = usePreferences();
  return (
    <ThemeProvider theme={makeTheme(mode)}>
      <CssBaseline />
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="satsang" element={<SatsangPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="events/:id" element={<EventDetailPage />} />
            <Route path="audio" element={<AudioPage />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="video" element={<Navigate to="/videos" replace />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="privacy" element={<LegalPage type="privacy" />} />
            <Route path="terms" element={<LegalPage type="terms" />} />
            <Route path="disclaimer" element={<LegalPage type="disclaimer" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<Navigate to="/admin/overview" replace />} />
          <Route path="/admin/:section" element={<ProtectedAdmin />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}
